module.exports = __webpack_public_path__ + "img/Simple Mart.c4510452.svg";